import { MenuItem } from '../types/navigation';

export const MENU_ITEMS: MenuItem[] = [
  {
    label: 'Home',
    href: '/',
  },
  {
    label: 'Services',
    href: '/services',
    subItems: [
      { label: 'Design Engineering', href: '/services/design-engineering' },
      {
        label: 'Fabrication & Erection',
        href: '/services/fabrication-erection',
      },
      { label: 'Machining', href: '/services/machining' },
      { label: 'Plant Maintenance', href: '/services/plant-maintenance' },
    ],
  },
  {
    label: 'About Us',
    href: '/about',
  },
  {
    label: 'Contact Us',
    href: '/contact',
  },
];
